import { render, staticRenderFns } from "./MarketDetail.vue?vue&type=template&id=f15658f4&scoped=true"
import script from "./MarketDetail.vue?vue&type=script&lang=js"
export * from "./MarketDetail.vue?vue&type=script&lang=js"
import style0 from "./MarketDetail.vue?vue&type=style&index=0&id=f15658f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15658f4",
  null
  
)

export default component.exports